export default "__VITE_ASSET__tie2DOU4__"